import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import {LayoutRoutes} from '../../routes/Routes'
import {Link} from "react-router-dom";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ReportIcon from '@material-ui/icons/Report';
import PrivateRoute from "../../utils/PrivateRoute";
import CategoryEditor from "../genre/GenreEditor";
import BookEditor from "../book/BookEditor";
import AuthorEditor from "../author/AuthorEditor";
import ListingEditor from "../listing/ListingEditor";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import FeedbackIcon from '@material-ui/icons/Feedback';
import PersonIcon from '@material-ui/icons/Person';
import UserEditor from "../user/UserEditor";


const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) => ({
        root: {
            display: 'flex',
        },
        drawer: {
            [theme.breakpoints.up('sm')]: {
                width: drawerWidth,
                flexShrink: 0,
            },
        },
        appBar: {
            [theme.breakpoints.up('sm')]: {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: drawerWidth,
            },
        },
        menuButton: {
            marginRight: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },
        // necessary for content to be below app bar
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: drawerWidth,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    }),
);

export default function Layout() {
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div>
            <div className={classes.toolbar}/>
            <List key={"menu-list"}>
                <ListItem
                    key={"Users"}
                    button
                    component={(props) => <Link {...props} to={"/admin/user"}/>}>
                    <ListItemIcon>
                        <PersonIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Потребители"}/>
                </ListItem>
                <ListItem
                    key={"Genres"}
                    button
                    component={(props) => <Link {...props} to={"/admin/genre"}/>}>
                    <ListItemIcon>
                        <LibraryBooksIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Жанрове"}/>
                </ListItem>
                <ListItem
                    key={"Authors"}
                    button
                    component={(props) => <Link {...props} to={"/admin/author"}/>}>
                    <ListItemIcon>
                        <PermContactCalendarIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Автори"}/>
                </ListItem>
                <ListItem
                    key={"Books"}
                    button
                    component={(props) => <Link {...props} to={"/admin/book"}/>}>
                    <ListItemIcon>
                        <MenuBookIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Книги"}/>
                </ListItem>
                <ListItem
                    key={"Listings"}
                    button
                    component={(props) => <Link {...props} to={"/admin/listing"}/>}>
                    <ListItemIcon>
                        <LibraryBooksIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Обяви"}/>
                </ListItem>
                <ListItem
                    key={"Reports"}
                    button
                    component={(props) => <Link {...props} to={"/admin/report"}/>}>
                    <ListItemIcon>
                        <ReportIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Доклади"}/>
                </ListItem>
                <ListItem
                    key={"Feedbacks"}
                    button
                    component={(props) => <Link {...props} to={"/admin/feedback"}/>}>
                    <ListItemIcon>
                        <FeedbackIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Обратна връзка"}/>
                </ListItem>
            </List>
        </div>
    );

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        Dashboard
                    </Typography>
                </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                <Hidden smUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar}/>
                {LayoutRoutes.map((layoutRout) =>
                    <PrivateRoute
                        key={`private-route-${layoutRout.label}`}
                        exact
                        path={layoutRout.path}
                        component={layoutRout.component}/>
                )}
                <PrivateRoute
                    exact
                    path={"/admin/genre/:id"}
                    component={CategoryEditor}/>
                <PrivateRoute
                    exact
                    path={"/admin/genre/:id/new"}
                    component={CategoryEditor}/>
                <PrivateRoute
                    exact
                    path={"/admin/author/:id"}
                    component={AuthorEditor}/>
                <PrivateRoute
                    exact
                    path={"/admin/book/:id"}
                    component={BookEditor}/>
                <PrivateRoute
                    exact
                    path={"/admin/listing/:id"}
                    component={ListingEditor}/>
                <PrivateRoute
                    exact
                    path={"/admin/user/:id"}
                    component={UserEditor}/>
            </main>
        </div>
    );
}
